module.exports = __webpack_public_path__ + "img/list-ico.b116f876.png";